// Calculator functionality for cloud cost optimization
document.addEventListener('DOMContentLoaded', function() {
    // Get calculator elements
    const annualCostInput = document.getElementById('annualCost');
    const savingsSlider = document.getElementById('savingsSlider');
    const savingsValue = document.getElementById('savingsPercent');
    const displayCost = document.getElementById('displayCost');
    const displayOptimized = document.getElementById('displayOptimized');
    const displaySavings = document.getElementById('displaySavings');
    const displayFee = document.getElementById('displayFee');
    const displayNet = document.getElementById('displayNet');
    const persistentSavings = document.getElementById('persistentSavings');

    // Helper function to format currency
    function formatCurrency(amount) {
        return '$' + amount.toLocaleString('en-US', { maximumFractionDigits: 0 });
    }

    // Calculate fee based on savings percentage
    function calculateFee(annualCost, savingsPercentage) {
        if (savingsPercentage >= 30) {
            return annualCost * 0.25;
        } else if (savingsPercentage >= 10) {
            return annualCost * 0.20;
        } else {
            return 0; // Free for <10%
        }
    }

    // Calculate net savings, ensuring no negative values
    function calculateNetSavings(savingsAmount, feeAmount) {
        const net = savingsAmount - feeAmount;
        return Math.max(0, net); // No negative net savings
    }

    // Initialize calculator
    function updateCalculator() {
        // Parse and validate inputs
        let annualCost = parseFloat(annualCostInput.value) || 0;
        annualCost = Math.max(0, annualCost); // No negative annual cost

        let savingsPercentage = parseInt(savingsSlider.value) || 0;
        savingsPercentage = Math.max(0, Math.min(100, savingsPercentage)); // Clamp to 0-100

        // Calculate potential savings
        const savingsAmount = (annualCost * savingsPercentage) / 100;

        // Calculate fee
        const feeAmount = calculateFee(annualCost, savingsPercentage);

        // Calculate net savings for client (no negatives)
        const netSavingsAmount = calculateNetSavings(savingsAmount, feeAmount);

        // Calculate optimized cost
        const optimizedCost = annualCost - savingsAmount;

        // Update display values
        if (savingsValue) savingsValue.textContent = savingsPercentage;
        if (displayCost) displayCost.textContent = formatCurrency(annualCost);
        if (displayOptimized) displayOptimized.textContent = formatCurrency(optimizedCost);
        if (displaySavings) displaySavings.textContent = formatCurrency(savingsAmount);
        if (persistentSavings) persistentSavings.textContent = formatCurrency(savingsAmount);
        if (displayFee) {
            const feePercentage = savingsPercentage >= 30 ? 25 : (savingsPercentage >= 10 ? 20 : 0);
            displayFee.textContent = formatCurrency(feeAmount) + ' (' + feePercentage + '%)';
        }
        if (displayNet) displayNet.textContent = formatCurrency(netSavingsAmount);
    }

    // Add event listeners
    if (annualCostInput) {
        annualCostInput.addEventListener('input', updateCalculator);
    }

    if (savingsSlider) {
        savingsSlider.addEventListener('input', function() {
            if (savingsValue) savingsValue.textContent = this.value;
            updateCalculator();
        });
    }

    // Initialize with default values
    updateCalculator();
});